
export type ChatRoomCreateRequestRoomInfoType = typeof ChatRoomCreateRequestRoomInfoType[keyof typeof ChatRoomCreateRequestRoomInfoType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ChatRoomCreateRequestRoomInfoType = {
  DIRECT: 'DIRECT',
  GROUP: 'GROUP',
} as const;
